import { memo, useEffect } from 'react';

import { Skeleton, Text } from '@chakra-ui/react';
import { BlobProviderParams } from '@react-pdf/renderer';

export type DownloadSyllabusBlobContainerProps = BlobProviderParams & {
  autoDownload?: boolean;
  downloadBaseName: string;
};

export const DownloadSyllabusBlobContainer = memo(function DownloadSyllabusBlobContainer({
  autoDownload = false,
  error,
  loading,
  blob,
  downloadBaseName,
}: DownloadSyllabusBlobContainerProps) {
  const url = blob ? URL.createObjectURL(blob) : null;

  useEffect(() => {
    if (!url) return;
    if (autoDownload) {
      const link = document.createElement('a');
      link.href = url;
      link.download = `${downloadBaseName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return () => URL.revokeObjectURL(url);
  }, [autoDownload, downloadBaseName, url]);

  if (error) return <Text>Error: {error.message}</Text>;
  if (loading) return <Skeleton height='100%' width='100%' />;
  if (!url) return null;

  return <iframe src={url} style={{ width: '100%', height: '100%', border: 'none' }} title={downloadBaseName} />;
});
